import $ from 'jquery';
import Api from '../utilities/Api';

$('.js-form-account-update').submit(async function (e) {
    e.preventDefault();

    $(this).find('.button').text('Сохранение...');
    const data = $(this).serializeObject();
    $('.header-profile__name, .left-menu__name').text(data.name);

    await Api.post('/api/v2/account/update/', data);
    $(this).find('.button').text('Сохранить');
});
